<section
  [ngClass]="
    'flex ' + getCssClass() + ' ' + fxLayoutInput + ' ' + fxLayoutAlignInput
  "
>
  <ng-content></ng-content>
</section>
